const STRIPE_ACCOUNT_LOAD_STATES = {
  LOADING: 'loading',
  READY: 'ready',
};

export default STRIPE_ACCOUNT_LOAD_STATES;
